"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RateLimitError = void 0;
const is_error_1 = require("./is-error");
const error_codes_1 = require("../lib/error-codes");
const args_1 = require("../lib/args");
/**
 * When the users hit a limit on the amount of requests per minute.
 */
class RateLimitError extends is_error_1.IsError {
    constructor(messageOrError, errorOrArgs, args) {
        const { message, originalError, errorArgs } = (0, args_1.readErrorArgs)(messageOrError, errorOrArgs, args);
        super(error_codes_1.StatusErrorCode.RATE_LIMIT, RateLimitError.name, message, errorArgs?.reasonCode || error_codes_1.ErrorGenericReasonCode.RATE_LIMIT, errorArgs?.userMessage || error_codes_1.ErrorMessage.RATE_LIMIT, originalError, errorArgs);
    }
}
exports.RateLimitError = RateLimitError;
